import { get, post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const API_NAME = 'HoneymoonRegistryAPI';

/**
 * Get authorization headers with Cognito ID token
 */
const getAuthHeaders = async () => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    
    return {
      'Content-Type': 'application/json',
      'Authorization': idToken || '',
    };
  } catch (error) {
    console.error('Error getting auth token:', error);
    return {
      'Content-Type': 'application/json',
    };
  }
};

/**
 * Fetch all activities from the API
 */
export const fetchActivities = async () => {
  try {
    const headers = await getAuthHeaders();
    
    const restOperation = get({
      apiName: API_NAME,
      path: '/activities',
      options: {
        headers,
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    
    return response.activities || [];
  } catch (error) {
    console.error('Error fetching activities:', error);
    console.error('Error details:', error.response);
    throw new Error('Failed to fetch activities');
  }
};

/**
 * Record a donation
 */
export const recordDonation = async (donationData) => {
  try {
    const headers = await getAuthHeaders();
    
    const restOperation = post({
      apiName: API_NAME,
      path: '/donations',
      options: {
        body: donationData,
        headers,
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    
    return response;
  } catch (error) {
    console.error('Error recording donation:', error);
    console.error('Error details:', error.response);
    throw new Error('Failed to record donation');
  }
};
